<template>
  <el-dialog title="评审建议" width="30%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
    <el-form size="small" :model="form" ref="form" v-loading="loading"
             label-width="120px">
      <el-form-item label="评审建议：" prop="reviewSuggestion">
        <el-input
            maxlength="100"
            type="textarea"
            :rows="6"
            placeholder="请输入内容（限100字）"
            v-model.trim="form.reviewSuggestion">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text_center">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "auditForm",
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        reviewSuggestion: ''
      },
      metadataFonctionsModelDetailId: '',
      routeInfo: {},
      configId: '',
    }
  },
  methods: {
    // ids数据id数组，metadataFonctionsModelDetailId按钮id，configId业务配置id
    init(ids, metadataFonctionsModelDetailId, configId) {
      this.configId = configId
      this.visible = true
      this.metadataFonctionsModelDetailId = metadataFonctionsModelDetailId
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        this.form.ids = ids
        let dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
        this.routeInfo = dynamicMenuRoutes.filter(item => item.fullPath === this.$route.fullPath)[0]
      })
    },
    // 确定
    doSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$axios(this.api.metadata.batchUpdateDataByFonctionsModel, {
            ...this.form,
            metadataFonctionsModelDetailId: this.metadataFonctionsModelDetailId,
            menuId: this.routeInfo.meta.menuId,
            configId: this.configId,
          }, 'post').then(data => {
            if (data.status) {
              this.$message.success('操作成功')
              this.$emit('refreshData')
              this.visible = false
            } else {
              this.$message.error(data.msg)
            }
            this.loading = false

          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
